import { useStore } from "zustand";
import { useDashboardName } from "../../store/headerName";
import { useEffect, useRef, useState } from "react";
import { useForm } from "antd/es/form/Form";
import { Form } from "antd";
import FormCard from "../../components/card/FormCard";
import FormItemInput from "../../components/form-item/form-item-input";
import FormButton from "../../components/FormButton";
import { $api } from "../../helper";
import ImageCard from "../../components/card/ImageCard";
import PreviewFile from "../../components/PreviewFile";
import { tokenMock } from "../../helper/mock";
import { useNotify } from "../../helper/notify";
import { useNavigate, useParams } from "react-router";
import { GetFullMediaPath } from "../../helper/method";
import Quill from "quill";

export default function ManagementSection() {
  const notify = useNotify();
  const editorRef = useRef<HTMLDivElement | null>(null);
  const quillRef = useRef<Quill | null>(null);
  const params = useParams();
  const navigate = useNavigate();
  const { mutate, isPending } = $api.useMutation(
    "put",
    "/site-api/v1/section/",
  );
  const detail = $api.useQuery("get", "/site-api/v1/section-detail/", {
    params: {
      query: {
        section_u_id: params.sectionId ?? "",
      },
    },
  });
  const [form] = useForm();
  const [file, setFile] = useState<
    {
      file: File | undefined;
      fileUrl: string;
      id: string;
    }[]
  >([]);
  const [fileMobile, setFileMobile] = useState<
    {
      file: File | undefined;
      fileUrl: string;
      id: string;
    }[]
  >([]);
  const { setDashboardName } = useStore(useDashboardName);
  useEffect(() => {
    setDashboardName("ویرایش محتوا");
    if (!editorRef.current) return;

    if (quillRef.current) return;

    quillRef.current = new Quill(editorRef.current, {
      theme: "snow",
      modules: {
        toolbar: [
          [{ header: [1, 2, 3, 4, 5, 6, false] }],
          ["bold", "italic", "underline", "strike"],
          [{ color: [] }, { background: [] }],
          [{ direction: "rtl" }],
          [{ align: [] }],
          ["link"],
          ["clean"],
        ],
      },
    });
  }, []);

  useEffect(() => {
    if (params.sectionId && detail.data) {
      Object.entries(detail.data?.data)?.forEach(([key, value]) => {
        form.setFieldValue(
          key,
          typeof value !== "boolean" ? value?.toString() : "",
        );
      });
      quillRef.current?.clipboard.dangerouslyPasteHTML(
        detail.data.data.description ?? "",
      );
    }
  }, [detail.data]);

  useEffect(() => {
    if (quillRef.current) {
      quillRef.current.format("align", "right");
      quillRef.current.on("text-change", () => {
        form.setFieldValue(
          "description",
          Number(quillRef.current?.editor.delta.ops[0].insert?.length) <= 1
            ? ""
            : quillRef.current && quillRef.current.root.innerHTML,
        );
      });
    }
  }, [quillRef.current?.editor.getText]);

  useEffect(() => {
    if (detail.data?.data) {
      setFile([
        {
          file: undefined,
          fileUrl: detail.data.data.file
            ? GetFullMediaPath(detail.data.data.file)
            : "",
          id: detail.data.data.file?.toString() ?? "",
        },
      ]);
      setFileMobile([
        {
          file: undefined,
          fileUrl: detail.data.data.additional_file
            ? GetFullMediaPath(detail.data.data.additional_file)
            : "",
          id: detail.data.data.additional_file?.toString() ?? "",
        },
      ]);
      Object.entries(detail.data?.data).forEach(([key, value]) => {
        form.setFieldValue(key, value?.toString());
      });
    }
  }, [detail.data]);

  const onFinish = (
    values: {
      title: string;
      sub_title: string;
      description: string;
      link: string;
      link_title: string;
    },
    redirect = true,
  ) => {
    const formData = new FormData();
    formData.append("section_u_id", params.sectionId ?? "");
    if (detail.data?.data.show_description) {
      formData.append(
        "description",
        values.description ?? detail.data?.data.description ?? "",
      );
    }
    formData.append("link", values.link ?? detail.data?.data.link ?? "");
    formData.append(
      "link_title",
      values.link_title ?? detail.data?.data.link_title ?? "",
    );
    formData.append(
      "sub_title",
      values.sub_title ?? detail.data?.data.sub_title ?? "",
    );
    formData.append("title", values.title ?? detail.data?.data.title ?? "");
    file.forEach((e) => {
      formData.append("file", e.file ? e.file : e.fileUrl ? e.fileUrl : "");
    });
    fileMobile.forEach((e) => {
      formData.append(
        "additional_file",
        e.file ? e.file : e.fileUrl ? e.fileUrl : "",
      );
    });
    mutate(
      {
        body: formData,
        headers: {
          Authorization: tokenMock,
          lang: "fa",
        },
      },
      {
        onSuccess: (data) => {
          notify.success(data.message);
          if (redirect) {
            navigate(`/management-page/${params.id}`);
          } else {
            setTimeout(() => {
              window.location.href = window.location.pathname;
            }, 1000);
          }
        },
      },
    );
  };

  return (
    <Form
      form={form}
      onFinish={(e) => onFinish(e)}
      layout="vertical"
      className="flex! flex-col! gap-6!"
    >
      <FormCard
        subTitle="تعریف و تنظیمات پایه مربوط به اطلاعات بخش"
        title="اطلاعات بخش"
      >
        <div className="grid sm:grid-cols-2 grid-cols-1 w-full gap-6">
          {detail.data?.data.show_title ? (
            <FormItemInput
              name={"title"}
              className="col-span-1"
              label="عنوان"
              inputProps={{
                placeholder: "لطفا عنوان خود را وارد کنید.",
              }}
            />
          ) : (
            ""
          )}
          {detail.data?.data.show_sub_title ? (
            <FormItemInput
              name={"sub_title"}
              className="col-span-1"
              label="عنوان فرعی"
              inputProps={{
                placeholder: "لطفا عنوان سوال خود را وارد کنید.",
              }}
            />
          ) : (
            ""
          )}
          {detail.data?.data.show_link ? (
            <FormItemInput
              name={"link"}
              rules={[{ type: "url", message: "لینک معتبر وارد کن" }]}
              className="col-span-1"
              label="لینک"
              inputProps={{
                placeholder: "لطفا لینک خود را وارد کنید.",
              }}
            />
          ) : (
            ""
          )}
          {detail.data?.data.show_link_title ? (
            <FormItemInput
              name={"link_title"}
              className="col-span-1"
              label="عنوان لینک"
              inputProps={{
                placeholder: "لطفا عنوان لینک خود را وارد کنید.",
              }}
            />
          ) : (
            ""
          )}
        </div>
      </FormCard>
      <div
        className={
          detail.data?.data.show_description ? "flex w-full" : "hidden"
        }
      >
        <FormCard subTitle="متن کامل سوال" title="متن">
          <div className="grid grid-cols-2 w-full gap-6">
            <div className="col-span-2">
              <Form.Item name={"description"} label="توضیحات کامل">
                <div
                  dir="auto"
                  className="w-full border-r border-l border-b border-grayscale-200 h-96! rounded-br-xl rounded-bl-xl"
                  lang="fa"
                  ref={editorRef}
                />
              </Form.Item>
            </div>
          </div>
        </FormCard>
      </div>
      {detail.data?.data.show_file || detail.data?.data.show_additional_file ? (
        <FormCard
          subTitle="تصاویر مربوط به نمایش بخش مربوط در نسخه‌های مختلف"
          title="تصاویر بخش مربوط"
        >
          <div className="grid sm:grid-cols-2 grid-cols-1 w-full gap-6">
            {detail.data?.data.show_file ? (
              <div className="col-span-1 flex h-fit flex-col gap-2">
                <ImageCard
                  file={file}
                  setFile={setFile}
                  id="image1-1"
                  name="file"
                  required={false}
                />
                {(file[0]?.file || file[0]?.fileUrl) &&
                  file?.map((e, i) => (
                    <div className="w-40 h-40">
                      <PreviewFile
                        id={e.id}
                        setFile={setFile}
                        url={e.fileUrl}
                        key={"preview-category" + i}
                      />
                    </div>
                  ))}
              </div>
            ) : (
              ""
            )}
            {detail.data?.data.show_additional_file ? (
              <div className="col-span-1 flex h-fit flex-col gap-2">
                <ImageCard
                  mobile
                  file={fileMobile}
                  setFile={setFileMobile}
                  id="image2-2"
                  name="additional_file"
                  required={false}
                />
                {(fileMobile[0]?.file || fileMobile[0]?.fileUrl) &&
                  fileMobile?.map((e, i) => (
                    <div
                      className="w-40 h-40"
                      key={"preview-mobile-category" + i}
                    >
                      <PreviewFile
                        id={e.id}
                        setFile={setFileMobile}
                        url={e.fileUrl}
                      />
                    </div>
                  ))}
              </div>
            ) : (
              ""
            )}
          </div>
        </FormCard>
      ) : (
        ""
      )}
      <FormButton
        isPending={isPending}
        ActionSaveAndStay={() => {
          form.validateFields().then(() => {
            onFinish(form.getFieldsValue(), false);
          });
        }}
      />
    </Form>
  );
}
